import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  border: 0;\n  margin-left: 16px;\n  height: 100%;\n  padding: 0;\n  width: 20px;\n  background-color: transparent;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-basis: 100%;\n  justify-content: end;\n  height: 100%;\n  align-items: center;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n  flex-basis: 100%;\n  height: 100%;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  width: 76px;\n  flex-basis: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 16px;\n\n  ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  opacity: 0.6;\n  font-size: 12px;\n  color: ", ";\n  font-weight: 500;\n  line-height: 22px;\n  ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      opacity: ", ";\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  white-space: nowrap;\n  position: relative;\n  align-items: center;\n  ", "\n\n  ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  background-color: transparent;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  border: 0;\n  padding: 0;\n  width: 24px;\n  height: 24px;\n  background-color: transparent;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  height: 66px;\n  left: 0;\n  right: 0;\n  width: 100%;\n  transition: height 0.1s;\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  align-items: center;\n  z-index: 20;\n  \n  @media screen and (min-width: ", "px) {\n    top: 80px;\n  }\n  @media screen and (min-width: ", "px) {\n    ", "\n  }\n\n  @media screen and (max-width: ", "px) {\n    background-color: transparent;\n    ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      opacity: ", ";\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding-right: 18px;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  font-size: 14px;\n  font-weight: 600;\n  height: 64px;\n  justify-content: space-between;\n  left: 0;\n  position: absolute;\n  ", "\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { AcornsIcon } from '@acorns/icons';
import { motion } from 'framer-motion';
import { hasSideNavigationBar } from '../utils/has-side-navigation-bar';
import styled, { css } from '../utils/styling/styled-components';
import { theme } from '../theme';
import { ACTION_STRIP_SUBTEXT, ACTION_STRIP_TITLE } from '../utils/testing/TestIDs';
import { useScrollHeight } from './hooks';
var Container = styled.div(_templateObject(), function (props) {
  return !props.isNavEnabled && "top: 70px;";
});
var ActionContainer = styled.div(_templateObject2(), function (props) {
  return !props.showChildrenIconsOnLoad && css(_templateObject3(), props.scrollPercent);
});
var Content = styled(motion.div)(_templateObject4(), function (props) {
  return !props.isNavEnabled && "top: 70px;";
}, theme.breakpoints.md + 1, theme.breakpoints.sm + 1, function (props) {
  return props.sticky && "\n      height: 64px;\n      position: fixed;\n    ";
}, theme.breakpoints.sm, function (props) {
  return !(props.isNavEnabled && props.isSafari) && 'transition: background-color 500ms linear, box-shadow 0.3s ease-in-out';
}, function (props) {
  return !props.isNavEnabled && (props.top ? "top: ".concat(props.top, "px;") : "top: 69px;");
}, function (props) {
  return props.scrollPercent >= 0.1 && !(props.scrollHeight >= props.verticalScrollHeight) && 'box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.04);';
}, function (props) {
  return props.scrollPercent >= 0.1 && "background-color: ".concat(props.stripColor, ";\n    ");
}, function (props) {
  return props.scrollHeight >= props.verticalScrollHeight && "\n        box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.04); \n        background-color: ".concat(props.stripTransitionColor, ";\n      ");
}, function (props) {
  return props.sticky && "\n        z-index: 20; \n        height: 66px;\n        position: fixed;\n      ";
});
var ActionButton = styled.button(_templateObject5());
var ActionComponent = styled.div(_templateObject6());
var Title = styled.div(_templateObject7(), function (props) {
  return !props.showTitleOnLoad && css(_templateObject8(), props.scrollPercent);
}, function (props) {
  return props.verticalSubText && "\n    flex-direction: column;\n    ";
});
var Subtext = styled.span(_templateObject9(), function (props) {
  return props.subtextColorOnLoad;
}, function (props) {
  return props.scrollHeight >= props.verticalScrollHeight && "color:".concat(theme.colors.slate);
});
var TitleText = styled.span(_templateObject10(), function (props) {
  return props.titleColorOnLoad;
}, function (props) {
  return props.scrollHeight >= props.verticalScrollHeight && "color:".concat(theme.colors.slate);
});
var BackContainer = styled.div(_templateObject11());
var TitleContainer = styled.div(_templateObject12());
var ChildrenContainer = styled.div(_templateObject13());
var Button = styled.button(_templateObject14());

var ActionContainerContent = function ActionContainerContent(_ref) {
  var scrollPercent = _ref.scrollPercent,
      showChildrenIconsOnLoad = _ref.showChildrenIconsOnLoad,
      child = _ref.child;
  return /*#__PURE__*/React.createElement(ActionContainer, {
    scrollPercent: scrollPercent,
    showChildrenIconsOnLoad: showChildrenIconsOnLoad
  }, child.component ? /*#__PURE__*/React.createElement(ActionComponent, {
    onClick: child.action,
    "data-testid": child.dataTestId
  }, child.component) : /*#__PURE__*/React.createElement(ActionButton, {
    onClick: child.action,
    "data-testid": child.dataTestId,
    "aria-label": child.ariaLabel || 'ActionStrip action'
  }, child.icon));
};

var InvertedStrip = function InvertedStrip(props) {
  var _useScrollHeight = useScrollHeight({
    scrollDistance: 64
  }),
      scrollHeight = _useScrollHeight.scrollHeight;

  var isSBNavEnabled = hasSideNavigationBar();
  var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
  return /*#__PURE__*/React.createElement(Container, {
    className: props.className,
    isNavEnabled: isSBNavEnabled
  }, /*#__PURE__*/React.createElement(Content, {
    stripTransitionColor: props.stripTransitionColor,
    stripColor: props.stripColor,
    scrollHeight: scrollHeight,
    verticalScrollHeight: props.verticalScrollHeight,
    scrollPercent: props.scrollPercent,
    sticky: true,
    stickyHeight: props.stickyHeight,
    isNavEnabled: isSBNavEnabled,
    isSafari: isSafari
  }, /*#__PURE__*/React.createElement(BackContainer, null, props.leftActions ? /*#__PURE__*/React.createElement(React.Fragment, null, scrollHeight <= props.verticalScrollHeight ? /*#__PURE__*/React.createElement(React.Fragment, null, props.leftActions.leftActionsComponent, " ") : /*#__PURE__*/React.createElement(React.Fragment, null, props.leftActions.leftActionsComponentScrolled)) : /*#__PURE__*/React.createElement(React.Fragment, null), props.showBack && !props.leftActions && /*#__PURE__*/React.createElement(Button, {
    className: props.className,
    onClick: props.onBack
  }, props.icon || props.scrollIcon ? /*#__PURE__*/React.createElement(AcornsIcon, {
    height: '16px',
    width: '16px',
    icon: scrollHeight <= props.verticalScrollHeight ? props.icon || AcornsIcon.Icon.ArrowBack : props.scrollIcon || AcornsIcon.Icon.ArrowLeft
  }) : /*#__PURE__*/React.createElement(AcornsIcon, {
    height: '16px',
    width: '16px',
    icon: scrollHeight <= props.verticalScrollHeight ? props.icon || AcornsIcon.Icon.ArrowBack : props.scrollIcon || AcornsIcon.Icon.ArrowLeft
  }))), /*#__PURE__*/React.createElement(TitleContainer, null, /*#__PURE__*/React.createElement(Title, {
    verticalSubText: props.verticalSubText,
    showTitleOnLoad: props.showTitleOnLoad,
    scrollPercent: props.scrollPercent
  }, /*#__PURE__*/React.createElement(React.Fragment, null, props.title && /*#__PURE__*/React.createElement(TitleText, {
    "data-testid": ACTION_STRIP_TITLE,
    scrollHeight: scrollHeight,
    verticalScrollHeight: props.verticalScrollHeight,
    titleColorOnLoad: props.titleColorOnLoad
  }, props.title), props.subtext && /*#__PURE__*/React.createElement(Subtext, {
    "data-testid": ACTION_STRIP_SUBTEXT,
    scrollHeight: scrollHeight,
    verticalScrollHeight: props.verticalScrollHeight,
    subtextColorOnLoad: props.subtextColorOnLoad
  }, props.subtext)))), /*#__PURE__*/React.createElement(ChildrenContainer, null, props.children && props.childrenIcons && props.childrenIconsScrolled ? /*#__PURE__*/React.createElement(React.Fragment, null, props.children, scrollHeight <= props.verticalScrollHeight ? props.childrenIcons.map(function (child) {
    return /*#__PURE__*/React.createElement(ActionContainerContent, {
      scrollPercent: props.scrollPercent,
      showChildrenIconsOnLoad: props.showChildrenIconsOnLoad,
      child: child
    });
  }) : props.childrenIconsScrolled.map(function (child) {
    return /*#__PURE__*/React.createElement(ActionContainerContent, {
      scrollPercent: props.scrollPercent,
      showChildrenIconsOnLoad: props.showChildrenIconsOnLoad,
      child: child
    });
  })) : props.childrenIcons && props.childrenIconsScrolled ? /*#__PURE__*/React.createElement(React.Fragment, null, scrollHeight <= props.verticalScrollHeight ? props.childrenIcons.map(function (child) {
    return /*#__PURE__*/React.createElement(ActionContainerContent, {
      scrollPercent: props.scrollPercent,
      showChildrenIconsOnLoad: props.showChildrenIconsOnLoad,
      child: child
    });
  }) : props.childrenIconsScrolled.map(function (child) {
    return /*#__PURE__*/React.createElement(ActionContainerContent, {
      scrollPercent: props.scrollPercent,
      showChildrenIconsOnLoad: props.showChildrenIconsOnLoad,
      child: child
    });
  })) : props.children)));
};

export { InvertedStrip };